<app-nav-partner></app-nav-partner>
<div class="container mt-5">
    <h1 class="text-secondary">VISIT</h1>
    <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <thead>
            <th style="width:50px;">#</th>
            <th>Date</th>
            <th>IP</th>
          </thead>
          <tbody>
           <tr *ngFor="let item of model; let id = index">
              <td>{{ (currentPage - 1) * limit + id + 1 }}</td>
              <td>{{ item.access_date | date: 'dd-MM-yyyy H:mm:s'}}</td>
              <td>{{item.ip}}</td>
           </tr>
           <tr *ngIf="model.length === 0">
             <td colspan="3" class="text-center text-muted">No records found</td>
           </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <small class="text-muted">Total: {{ total }} records</small>
        <nav>
          <ul class="pagination pagination-sm mb-0 flex-wrap">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" (click)="goToPage(currentPage - 1)" style="cursor:pointer;">&#8249;</a>
            </li>
            <ng-container *ngFor="let p of pages">
              <li class="page-item disabled" *ngIf="p === '...'">
                <span class="page-link">…</span>
              </li>
              <li class="page-item" *ngIf="p !== '...'" [class.active]="p === currentPage">
                <a class="page-link" (click)="goToPage(+p)" style="cursor:pointer;">{{ p }}</a>
              </li>
            </ng-container>
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <a class="page-link" (click)="goToPage(currentPage + 1)" style="cursor:pointer;">&#8250;</a>
            </li>
          </ul>
        </nav>
      </div>

</div>
